module.exports = __webpack_public_path__ + "static/img/school-1.68046f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-1.png
// module id = Nvgv
// module chunks = 1